export enum ProviderPanelTabs {
  Info = 'INFO',
  Chat = 'CHAT',
  Transfer = 'TRANSFER',
  More = 'MORE',
}
